<template>
  <div class="max-width">
    <div class="subs">
      <router-link to="/" class="subs__links">Home</router-link>
      <span>Terms & Conditions</span>
    </div>

    <div class="page">
      <h1 class="section__title">Terms & Conditions</h1>

      <div class="page__content">
        <h2>Introduction</h2>
        <p>Thank you for visiting Creative Commerce. We create products to enhance your website building experience. Please read these Terms of Service as you must agree in order to use our Service.</p>

        <h2>Definitions</h2>

        <p>Throughout this Agreement, certain words or phrases have specific meanings:</p>
        <blockquote>“Agreement” refers to these Terms & Conditions.</blockquote>
        <blockquote>“Service” refers to the services that we provide, including our Shopify themes (whether obtained via Shopify, our Site, directly via e-mail, or otherwise) and our Site itself.</blockquote>
        <blockquote>“Site” refers to our website: <a href="https://creativecommercelabs.com" target="_blank">https://creativecommercelabs.com</a>.</blockquote>
        <blockquote>“Creative Commerce” refers to our company, our Site, our Service, or a combination thereof depending on context.</blockquote>
        <blockquote>“User” refers to anyone who uses our Service, including visitors to our Site.</blockquote>
        <blockquote>“You” refers to the person entering into this Agreement with Creative Commerce.</blockquote>

        <h2>What We Offer</h2>
        <p>Creative Commerce is an online company that creates Shopify themes. We sell these themes exclusively on Shopify.com (“Shopify”). Shopify controls the transaction, pricing, support policy, and manages the license for each purchase.</p>
        <p>Creative Commerce offers technical support to anyone who buys our theme from Shopify. This support is available on our support page:
          <a href="https://creativecommercelabs.com/help-center" target="_blank">https://creativecommercelabs.com/help-center</a>. Only verified Shopify buyers can access our support using their Shopify purchase code.</p>

        <h2>Eligibility</h2>
        <p>To use our Service, you must:</p>
        <p>Do not violate any local or international laws applicable to your location.</p>
        <p>Be at least 18 years old or the minimum legal age to enter into a contract in your jurisdiction.</p>
        <p>If signing up on behalf of an organization, be authorized to bind the organization to this Agreement.</p>
        <p>Provide personal information required to use our Service.</p>

        <h2>Nature of Service</h2>

        <p>Creative Commerce offers templates but makes no representations, warranties, or endorsements regarding content displayed using such templates. You acknowledge that Creative Commerce does not endorse websites built with its templates and release us from any liability relating to acts or omissions of Users.</p>

        <h2>Rules of Use</h2>
        <p>You must not:</p>
        <ul>
          <li>Violate any applicable laws.</li>
          <li>Post or send violent, pornographic, racist, hateful, or otherwise objectionable content.</li>
          <li>Infringe intellectual property rights, defame, impersonate, or violate the rights of others.</li>
          <li>Compromise the security of our Site, Service, or other Users’ devices.</li>
          <li>Engage in actions that could bring Creative Commerce into disrepute.</li>
        </ul>

        <h2>Copyright & Intellectual Property</h2>
        <p><strong>Our Copyright:</strong> Do not copy, distribute, display, or reproduce any information on the Site without prior written permission.</p>
        <p><strong>Your Content:</strong> By submitting content to Creative Commerce, you grant us a non-exclusive, universal, perpetual, irrevocable, sublicensable, commercial and non-commercial right to use, distribute, sell, publish, and otherwise make use of the content. You warrant that you have the rights to grant this license and indemnify Creative Commerce for any breach.</p>

        <h2>Revocation of Consent</h2>

        <p>Creative Commerce may revoke your permission to use our intellectual property at any time. You agree to remove usage immediately upon request.</p>

        <h2>Copyright & Trademark Infringement</h2>
        <p>To report infringement, provide:</p>
        <ul>
          <li>Your name and contact information.
            The name of the party whose copyright is infringed.
            Description of the work and location on our Site.
            A statement of good faith belief that use is unauthorized.</li>
        </ul>
        <p>Submit notices via: <a href="https://creativecommercelabs.com/help-center/#support" target="_blank">https://creativecommercelabs.com/help-center/#support</a>.</p>

        <h2>Defamation</h2>

        <p>Creative Commerce prohibits defamation. If you believe a User has posted defamatory content, notify us at <a
            href="https://creativecommercelabs.com/help-center/#support" target="_blank">https://creativecommercelabs.com/help-center/#support</a>.</p>

        <h2>Representations & Warranties</h2>
        <p>We make no warranties regarding the merchantability or fitness of our Service for any purpose. You release Creative Commerce from liability arising from our Service, including failure of service, negligence, or other causes.</p>
        <p>Creative Commerce is not responsible for damages caused by third parties, or for failures or disruptions of our or third-party goods or services.</p>

        <h2>Indemnity</h2>

        <p>You agree to indemnify Creative Commerce for any claims arising from your use of our Service, including legal fees, court costs, and disbursements.</p>

        <h2>Governing Law & Disputes</h2>

        <p>This Agreement shall be governed by applicable law. Any disputes arising under this Agreement shall be resolved in a competent court with jurisdiction over the matter.</p>

        <h2>Force Majeure</h2>

        <p>Creative Commerce is not liable for events beyond our control, including acts of God, war, terrorism, labor strikes, postal or communication disruptions, or shortages of materials or infrastructure.</p>

        <h2>Severability</h2>

        <p>If a provision is found unlawful or unenforceable, the remainder of the Agreement remains in effect. Creative Commerce may choose which conflicting provisions remain in force.</p>

        <h2>Non-Waiver</h2>

        <p>Failure to enforce any provision does not waive the right to enforce it in the future.</p>

        <h2>Termination & Cancellation</h2>

        <p>Creative Commerce reserves all rights under this Agreement and applicable law.</p>

        <h2>Assignment of Rights</h2>

        <p>You may not assign your rights or obligations without Creative Commerce’s written consent. We may assign our rights or obligations at our discretion.</p>

        <h2>Amendments</h2>

        <p>We may update these Terms & Conditions from time to time. Continued use of our Service indicates acceptance of any updates.</p>

        <h2>Refund Policy</h2>

        <p>According to Shopify rules, theme refunds are not allowed due to the nature of digital products. Once a theme is purchased and downloaded, it cannot be returned or refunded.</p>
        <p>Reasons for this policy:</p>
        <ul>
          <li><strong>Instant Access:</strong> Customers gain immediate access to files.</li>
          <li><strong>Intellectual Property Protection:</strong> Prevents unauthorized distribution or misuse.</li>
          <li><strong>Customization Potential:</strong> Purchased themes may be customized; refunds are impractical.</li>
        </ul>
        <p>We recommend thoroughly researching demos, reviews, and support documentation before purchase.</p>

      </div>
    </div>
  </div>
</template>
<script setup>
</script>
